import React, { useEffect, useState } from "react";
import SideBar from "../PosGas/SideBar";
import TopNav from "../TopNav";
import Footer from "../Footer";
import { API_URL } from "../config";
import { Modal, Button, Card } from 'react-bootstrap';
import Swal from 'sweetalert2';

const priceCategories = [
  "lpgas_wholesale_cash",
  "lpgas_wholesale_eco",
  "lpgas_wholesale_usd",
  "lpgas_wholesale_zpt",
  "lpgas_wholesale_zar",
  "lpgas_retail_cash",
  "lpgas_retail_eco",
  "lpgas_retail_usd",
  "lpgas_retail_zpt",
  "lpgas_retail_zar",
];

const MySite = () => {
  const [branches, setBranches] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [companyId, setCompanyId] = useState();
  const [prices, setPrices] = useState({});
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // Vertical Progress Bar Component
  const VerticalProgressBar = ({ capacity }) => {
    const filledHeight = Math.max(0, Math.min(100, capacity));

    return (
      <div style={styles.progressContainer}>
        <div style={{ ...styles.progressBar, height: `${filledHeight}%` }} />
        <span style={styles.capacityText}>{filledHeight}%</span>
      </div>
    );
  };

  const styles = {
    progressContainer: {
      height: '550px', // Set desired height
      width: '200px',   // Set desired width
      backgroundColor: '#e0e0e0',
      position: 'relative',
      borderRadius: '10px',
      overflow: 'hidden',
      marginTop: '20px',
    },
    progressBar: {
      backgroundColor: '#65FE08',
      width: '100%',
      position: 'absolute',
      bottom: 0,
      transition: 'height 2.0s ease',
    },
    capacityText: {
      position: 'absolute',
      bottom: '5px',
      left: '50%',
      transform: 'translateX(-50%)',
      color: 'black',
      fontWeight: 'bold',
    },
  };

  useEffect(() => {
    const storedCompanyId = localStorage.getItem("company_id");
    setCompanyId(storedCompanyId);
    
    const fetchCompanies = async () => {
      try {
        const response = await fetch(`${API_URL}/companies`);
        const data = await response.json();
        setCompanies(data);
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchCompanies();
  }, []);

  useEffect(() => {
    const fetchBranches = async () => {
      if (companyId) {
        try {
          const response = await fetch(`${API_URL}/branches/company/${companyId}`);
          const data = await response.json();
          setBranches(data);
          console.log("branches retrieved", data);
          updateLatestInventoryLevels(data);
        } catch (error) {
          console.log(error.message);
        }
      }
    };

    const updateLatestInventoryLevels = async (branches) => {
      if (!branches || branches.length === 0) {
        console.log("No branches to update.");
        return;
      }

      for (const branch of branches) {
        let branchtoupdate = branch.branch_id;
        console.log(branchtoupdate); // Output the branch_id

        let lastCloseStock;
        try {
          const response = await fetch(`${API_URL}/inventory/lastClose/${branchtoupdate}`);
          lastCloseStock = await response.json();
          console.log("retrieved last close stock", branchtoupdate, lastCloseStock.closing_inventory);
        } catch (error) {
          console.log(error.message);
          continue; // Skip this branch if an error occurs
        }

        try {
          const body = {
            inventory_level: lastCloseStock.closing_inventory,
          };

          const response = await fetch(`${API_URL}/branches/update_inventory/${branchtoupdate}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });

          const data = await response.json();
          console.log("Branch stock level updated", branchtoupdate, data);
        } catch (error) {
          console.log(error.message);
        }
      }
    };

    fetchBranches();
  }, [companyId]);

  useEffect(() => {
    const fetchPrices = async () => {
      const storedCompanyId = localStorage.getItem("company_id");
      if (selectedBranch) {
        try {
          const response = await fetch(`${API_URL}/salesprices/lastprice/branchid/${selectedBranch.branch_id}/companyid/${storedCompanyId}`);
          const data = await response.json();

          const pricesMap = {};
          data.forEach(price => {
            pricesMap[price.item] = price.price;
          });

          setPrices(pricesMap);
        } catch (error) {
          console.log(error.message);
        }
      }
    };

    fetchPrices();
  }, [selectedBranch]);

  const handleBranchChange = (event) => {
    const selectedId = event.target.value;
    const branch = branches.find(branch => branch.branch_id === parseInt(selectedId));
    setSelectedBranch(branch);
  };

  const handlePriceEdit = () => {
    setShowPriceModal(true);
  };

  const handleClosePriceModal = () => {
    setShowPriceModal(false);
  };

  const handleActualInsertPrices = async (pricesToInsert) => {
    const userId = localStorage.getItem("user") || "Unknown User";
    const now = new Date().toISOString();
    
    setLoading(true);

    try {
      for (const priceEntry of pricesToInsert) {
        const priceData = {
          sales_prices_id: null,
          item: priceEntry.itemType,
          price: priceEntry.price,
          changed_by: userId,
          changed_on: now,
          company_id: companyId,
          branch_id: selectedBranch.branch_id,
          sync_date_time: now,
          sync_id: null,
          sync_status: 'Pending',
        };

        const response = await fetch(`${API_URL}/salesprices`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(priceData),
        });

        const responseText = await response.text();

        if (!response.ok) {
          console.error('Failed to insert price:', responseText);
          const errorData = JSON.parse(responseText);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: `Failed to insert price for ${priceEntry.itemType}.`,
            footer: `<p>${errorData.message || 'Unknown error occurred.'}</p>`,
          });
          continue;
        }

        const insertedData = JSON.parse(responseText);
        console.log('Inserted price:', insertedData);
      }

      handleClosePriceModal();
    } catch (error) {
      console.error('Error saving prices:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'An unexpected error occurred. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePriceChange = (category, value) => {
    setPrices(prevPrices => ({
      ...prevPrices,
      [category]: value,
    }));
  };

  const handleSavePrices = () => {
    const pricesToInsert = priceCategories.map(category => ({
      itemType: category,
      price: prices[category] || 0,
    }));

    handleActualInsertPrices(pricesToInsert);
  };

  return (
    <div className="dashboard-main-wrapper">
      <TopNav />
      <SideBar />

      <div className="container-fluid dashboard-content" style={{ textAlign: "center" }}>
        <div className="row" style={{ marginLeft: "1%", marginTop: "20px" }}>
          <h5 className="header" style={{ fontFamily: "sans-serif" }}>
            My Sites
          </h5>

          <div className="col-12">
            <select
              className="form-select"
              onChange={handleBranchChange}
              style={{ margin: "0 auto", width: "50%" }}
            >
              <option value="">Select a branch</option>
              {branches.map((branch) => (
                <option key={branch.branch_id} value={branch.branch_id}>
                  {branch.branch_name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {selectedBranch && (
          <>
            {/* Branch Details Card */}
            <div className="row" style={{ marginTop: "20px", justifyContent: "flex-end" }}>
              <div className="col-md-12" style={{ maxWidth: "70%" }}>
                <Card style={{ padding: "20px" }}>
                  <Card.Body>
                    <Card.Title className="text-center">{selectedBranch.branch_name}</Card.Title> 

                   
                    <div className="row" align="left">
                      <div className="col-md-8">
                        {/* Branch Information Section */}
                        <div className="card-container">
                          <h5 style={{ fontWeight: 'bold' }}>Branch Information</h5>
                          <div className="inner-card-container">
                            <div className="row">
                              <div className="col-md-4">Branch:</div>
                              <div className="col-md-8">{selectedBranch.branch_name}</div>

                              <div className="col-md-4">Location:</div>
                              <div className="col-md-8">{selectedBranch.branch_location}</div>

                              <div className="col-md-4">Location Notes:</div>
                              <div className="col-md-8">{selectedBranch.branch_location_notes}</div>

                              <div className="col-md-4">City:</div>
                              <div className="col-md-8">{selectedBranch.branch_city}</div>
                            </div>
                          </div>
                        </div>

                        {/* Contact Information Section */}
                        <div className="card-container">
                          <h5 style={{ fontWeight: 'bold' }}>Contact Information</h5>
                          <div className="inner-card-container">
                            <div className="row">
                              <div className="col-md-4">Phone:</div>
                              <div className="col-md-8">{selectedBranch.phone}</div>

                              <div className="col-md-4">Email:</div>
                              <div className="col-md-8">{selectedBranch.email || 'N/A'}</div>
                            </div>
                          </div>
                        </div>

                        {/* Inventory Details Section */}
                        <div className="card-container">
                          <h5 style={{ fontWeight: 'bold' }}>Inventory Details</h5>
                          <div className="inner-card-container">
                            <div className="row">
                              <div className="col-md-4">Sync Interval:</div>
                              <div className="col-md-8">{selectedBranch.sync_interval}</div>

                              <div className="col-md-4">Reorder Level (kgs):</div>
                              <div className="col-md-8">{selectedBranch.branch_reorder_level_kgs}</div>

                              <div className="col-md-4">Auto Reorder Status:</div>
                              <div className="col-md-8">{selectedBranch.auto_branch_reorder_status}</div>

                              <div className="col-md-4">Inventory Level:</div>
                              <div className="col-md-8">{selectedBranch.inventory_level}</div>

                              <div className="col-md-4">Storage Capacity (kgs):</div>
                              <div className="col-md-8">{selectedBranch.inventory_storage_capacity}</div>

                              <div className="col-md-4">Status:</div>
                              <div className="col-md-8">{selectedBranch.status}</div>

                              <div className="col-md-4">Multi Sync Control Status:</div>
                              <div className="col-md-8">{selectedBranch.multi_sync_control_status}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 col-xs-12 col-sm-12" align="center">
                      <h5 style={{ fontWeight: 'bold' }}>Branch Information</h5>
                      <h5 style={{ fontWeight: 'bold',color:"blue",fontSize:18 }}> {selectedBranch.inventory_level}KGS</h5>
                      
                        {/* Vertical Progress Bar */}
                        <VerticalProgressBar capacity={((selectedBranch.inventory_level / selectedBranch.inventory_storage_capacity) * 100)} />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>

            {/* Prices Card */}
            <div className="row" style={{ marginTop: "20px", justifyContent: "flex-end" }}>
              <div className="col-md-12" style={{ maxWidth: "70%" }}>
                <div className="card-container">
                  <h5 style={{ fontWeight: 'bold' }}>Prices</h5>
                  <div className="inner-card-container">
                    <div className="row" style={{ textAlign: 'left' }}>
                      {priceCategories.map(category => (
                        <div key={category} className="col-md-12" style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
                          <strong>{category.replace(/_/g, ' ')}</strong>
                          <span>${prices[category] !== undefined ? prices[category] : 0}</span>
                        </div>
                      ))}
                    </div>
                    <Button variant="primary" onClick={handlePriceEdit} style={{ marginTop: '15px' }}>Edit Prices</Button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Price Edit Modal */}
      <Modal show={showPriceModal} onHide={handleClosePriceModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Prices for {selectedBranch?.branch_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {priceCategories.map(category => (
            <div key={category} className="d-flex align-items-center" style={{ marginBottom: '15px' }}>
              <label style={{ width: '50%', margin: 0 }}>{category.replace(/_/g, ' ')}</label>
              <input
                type="number"
                value={prices[category] || 0}
                onChange={(e) => handlePriceChange(category, e.target.value)}
                style={{ marginLeft: '10px', width: '50%' }}
              />
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosePriceModal}>Close</Button>
          <Button variant="primary" onClick={handleSavePrices} disabled={loading}>
            {loading ? 'Saving...' : 'Save Changes'}
          </Button>
        </Modal.Footer>
      </Modal>

      <div style={{ width: "100%", float: "right" }}>
        <Footer />
      </div>

      <style>
        {`
          .card-container {
            background-color: white;
            border: 1px solid #ccc; /* Grey outline */
            border-radius: 8px; /* Rounded corners */
            padding: 15px;
            margin-bottom: 15px; /* Space between cards */
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Subtle shadow */
          }
          .inner-card-container {
            background-color: rgb(248, 232, 248); /* Light grey background */
            border: 1px solid #ddd; /* Light grey outline */
            border-radius: 6px; /* Rounded corners */
            padding: 10px;
          }
          h5 {
            margin-bottom: 10px; /* Space below section headers */
          }
        `}
      </style>

      <script src="../assets/vendor/jquery/jquery-3.3.1.min.js"></script>
      <script src="../assets/vendor/bootstrap/js/bootstrap.bundle.js"></script>
      <script src="../assets/vendor/slimscroll/jquery.slimscroll.js"></script>
      <script src="../assets/libs/js/main-js.js"></script>
    </div>
  );
};

export default MySite;